var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8436 22.4871H15.8653H15.8436ZM27.2187 15.5L15.8653 22.5V22.5154L19.6538 29.5H27.2187L31 22.5L27.2187 15.5ZM1 22.5L4.78127 29.5V15.5L1 22.5ZM15.7619 22.3355L15.8436 8.5L27.2187 15.5L19.9088 1.5H12.3462L4.78127 15.5L15.8461 22.4871L15.7619 22.3355ZM4.78127 29.5H12.3462L15.8581 22.5154L4.78127 29.5Z",
    fill: "url(#paint0_linear_703_11679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_703_11679",
    x1: 23.2414,
    y1: -2.98,
    x2: -1.01255,
    y2: 22.5479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#315EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#6F25D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB9BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSmall);
export default __webpack_public_path__ + "static/media/icoSmall.a92666f12078685c45ad3efdad599246.svg";
export { ForwardRef as ReactComponent };